import jobsort from "../services/jobsort";
import combine from "../services/combine-service";
const jobs = {
  assignedjobs: []
};
export default function (state = jobs, action) {
  var payload;
  switch (action.type) {
    case "RealTimeUpdate for assignedjobs":
      if (action.payload.data) {
        action.payload = action.payload.data;
      }
      // var Assignments = new List(action.payload);
      //Assignments.sort('assigned_task', { order: 'asc' });
      //  console.log('All Assignments', Assignments);
      var jobs = Array.from(action.payload);
      return {
        ...state,
        assignedjobs: jobsort.assignments(jobs)
      };
      break;
    case "Update > assign":
      return {
        ...state,
        assignedjobs: combine(
          state.assignedjobs,
          action.payload,
          "id",
          action.deletestatus
        )
      };
      break;
    case 'assign - jobReducer':
      return {
        ...state,
        assignedjobs: action.payload
      };
      break;
    default:
      return state;
  }
  return state;
}


// WEBPACK FOOTER //
// ./src/reducers/job-reducer.js